import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle2 } from 'lucide-react';
import { Dialog, DialogContent, DialogDescription, DialogTitle } from 'components/ui/dialog';
import { Button } from 'components/ui/button';
import { ui } from '../ui';

interface Props {
  open: boolean;
  onClose: () => void;
}

/** Design `DoneDialog`: confirmation after a help request or an identity answer. */
export function DoneDialog({ open, onClose }: Props) {
  const { t } = useTranslation('publishing');
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-[400px] gap-0 p-6">
        <div className="flex flex-col items-center gap-3 py-2 text-center">
          <CheckCircle2 size={30} className="text-green-600" />
          <DialogTitle className={ui.subhead}>{t('done_title')}</DialogTitle>
          <DialogDescription className={ui.muted}>{t('done_body')}</DialogDescription>
          <Button className={`mt-2 min-w-[120px] ${ui.btnPrimary}`} onClick={onClose}>
            {t('done_button')}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
